import { render, staticRenderFns } from "./SelfInfo.vue?vue&type=template&id=c1a2d70e&scoped=true&"
import script from "./SelfInfo.vue?vue&type=script&lang=ts&"
export * from "./SelfInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SelfInfo.vue?vue&type=style&index=0&id=c1a2d70e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a2d70e",
  null
  
)

export default component.exports